var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartsTab2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6038 15.6992L17.255 13.048L24.75 20.5429L22.0987 23.1942L14.6038 15.6992ZM19.25 9.2342C21.6625 9.2342 23.625 7.2717 23.625 4.8592C23.625 4.1342 23.425 3.4592 23.1125 2.8592L19.7375 6.2342L17.875 4.3717L21.25 0.9967C20.65 0.6842 19.975 0.4842 19.25 0.4842C16.8375 0.4842 14.875 2.4467 14.875 4.8592C14.875 5.3717 14.975 5.8592 15.1375 6.3092L12.825 8.6217L10.6 6.3967L11.4875 5.5092L9.725 3.7467L12.375 1.0967C11.6719 0.394448 10.7188 0 9.725 0C8.73125 0 7.77813 0.394448 7.075 1.0967L2.65 5.5217L4.4125 7.2842H0.8875L0 8.1717L4.425 12.5967L5.3125 11.7092V8.1717L7.075 9.9342L7.9625 9.0467L10.1875 11.2717L0.925 20.5342L3.575 23.1842L17.8 8.9717C18.25 9.1342 18.7375 9.2342 19.25 9.2342Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartsTab2);
export default __webpack_public_path__ + "static/media/parts-tab-2.cacbb3ed87837ec8168938a2770795b6.svg";
export { ForwardRef as ReactComponent };